// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g5VwZ","button-container":"styles_button-container__9fQIM","link-segundo-factor":"styles_link-segundo-factor__CC5Ct"};